import { Request, Response, NextFunction } from 'express';
import { Schema, ValidationError } from 'joi';
import { HttpException } from '../utils/exceptions/httpException';
import { status } from '../utils/helpers/api.responses';

export const validationMiddleware = (schema: Schema) => {
    return async (req: Request, res: Response, next: NextFunction) => {
        try {
            if (!req.body || Object.keys(req.body).length === 0) {
                return res.status(status.BadRequest).json({
                    status: status.BadRequest,
                    message: 'Request body cannot be empty',
                    errors: [{ field: 'body', message: 'Request body is required', type: 'emptyBody' }],
                });
            }

            const t = req.t || ((key: string, options?: any) => key);

            const { error } = await schema.validateAsync(req.body, {
                abortEarly: false,
                context: { t },
                stripUnknown: false,
            });

            if (error) {
                const errors = error.details.map((detail) => {
                    const key = detail.type;
                    const fieldLabel = detail.context?.label || detail.path.join('.');
                    const field = fieldLabel.includes('.') ? fieldLabel.split('.').pop() : fieldLabel;
                    // Use the custom message from context if available
                    const messageKey = detail.context?.message || key;
                    
                    const message = t(`Validation.${messageKey}`, {
                        field: t(`Labour.${detail.context?.label || detail.path.join('.')}`) || fieldLabel,
                        ...detail.context,
                    });
                    return {
                        field: fieldLabel,
                        message,
                        type: key,
                    };
                });

                return res.status(status.BadRequest).json({
                    status: status.BadRequest,
                    message: t('General.invalid', { field: 'Input' }),
                    errors,
                });
            }

            next();
        } catch (error: any) {
            console.error('Validation middleware error:', error);

            const t = req.t || ((key: string, options?: any) => key);

            if (error instanceof ValidationError && error.isJoi) {
                const errors = error.details.map((detail) => {
                    const key = detail.type;
                    const fieldLabel = detail.context?.label || detail.path.join('.');
                    const messageKey = detail.context?.message || key;
                    const message = t(`Validation.${messageKey}`, {
                        field: detail.context?.label || detail.path.join('.'),
                        // field: t(`Labour.${detail.context?.label || detail.path.join('.')}`) || fieldLabel,
                        ...detail.context,
                    });
                    return {
                        field: fieldLabel,
                        message,
                        type: key,
                    };
                });

                return res.status(status.BadRequest).json({
                    status: status.BadRequest,
                    message: t('General.invalid', { field: 'Input' }),
                    errors,
                });
            }

            if (error instanceof HttpException) {
                return res.status(error.status).json({
                    status: error.status,
                    message: error.message,
                });
            }

            return res.status(status.InternalServerError).json({
                status: status.InternalServerError,
                message: t('General.error'),
                errors: [],
            });
        }
    };
};